/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import withStyles from '@material-ui/styles/withStyles';
import TableCell from '@material-ui/core/TableCell';

export const StyledTableCell = withStyles({
  root: {
    borderRight: 'none',
    backgroundColor: 'inherit',
  },
})(TableCell);
